export default __webpack_public_path__ + "static/media/news_background_left.f9fdbad9.png";